import { config } from "../../utils/constants";
import axios from "axios";

export const getMedicalFitnessStatus = (refNo, dob) => {
  const requestConfig = {
    url: `${config.medicalFitnessService}getMedicalStatus`,
    data: {
      refNo, dob
    },
    method: "post"
  };

  // if (env) {
  //     return oAuthRequest(requestConfig)
  // }
  return axios.request(requestConfig);
};